import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dcf75916"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-check" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id"]

import { computed } from 'vue'
import * as log from '@/model/util/log/Logger'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
  // 要素のid
  domId: {
    type: String,
    default: '',
  },
  // データ
  modelValue: {
    type: Boolean,
    default: false,
  },
  // ラベル
  label: {
    type: String,
    default: '',
  },
},
  emits: ["update:modelValue", "input-enter"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'input-enter'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

log.trace(`BaseCheckbox setup start.`)
// プロパティ定義


// Emit定義

/**
 * チェックボックス算出プロパティ
 */
const checkValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    log.debug(`update:${value}`)
    emit('update:modelValue', value)
  },
})

/**
 * enter押下イベント
 * チェックボックスのon/offを切り替えを実施する
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onEnter = (event: any) => {
  log.trace(`BaseCheckbox onEnter start.`)
  const { checked } = event.target
  log.debug(`now-checked:${checked}`)
  const chgValue = !checked
  // checkValueを更新する事で親コンポーネントに通知する
  checkValue.value = chgValue
  log.trace(`BaseCheckbox onEnter end.`)
}

log.trace(`BaseCheckbox setup end.`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: props.domId,
      class: "form-check-label"
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: "form-check-input",
        id: props.domId,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checkValue) ? (checkValue).value = $event : null)),
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (onEnter($event)), ["enter"]))
      }, null, 40, _hoisted_3), [
        [_vModelCheckbox, _unref(checkValue)]
      ]),
      _createTextVNode(" " + _toDisplayString(props.label), 1)
    ], 8, _hoisted_2)
  ]))
}
}

})